module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/nomina/simulador/components/plazo-item/plazo-item.component.scss
// module id = ./src/app/creditos/nomina/simulador/components/plazo-item/plazo-item.component.scss
// module chunks = main